// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gesture-swipe-container {
    position: relative;
    height: 4rem;
    width: 4rem;
    background-color: var(--color-static-background);
    touch-action: none;
    border-radius: 50%;
    cursor: pointer;
}

.fingerprint-container {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 80%;
    width: 80%;
    /* Defaults for gesture behaviour */
    --gs-translate-x: 0px;
    --gs-transition-enabled: 1;
    transform: translate( calc(-50% + var(--gs-translate-x)), -50% );
    transition: transform calc(var(--gs-transition-enabled) * 0.25s) cubic-bezier(0.25, 0.8, 0.25, 1);
    pointer-events: none;
}

    .fingerprint-container.static {
        stroke: var(--color-static);
        z-index: 0;
    }

    .fingerprint-container.dynamic {
        stroke: var(--color-dynamic);
        z-index: 1;
    }

    .fingerprint-container > svg {
        pointer-events: none;
        height: 100%;
        width: 100%;
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/css/GestureSwipe.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,UAAU;IACV,mCAAmC;IACnC,qBAAqB;IACrB,0BAA0B;IAC1B,gEAAgE;IAChE,iGAAiG;IACjG,oBAAoB;AACxB;;IAEI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,4BAA4B;QAC5B,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,YAAY;QACZ,WAAW;IACf","sourcesContent":["@import '../../css/App.css';\r\n\r\n.gesture-swipe-container {\r\n    position: relative;\r\n    height: 4rem;\r\n    width: 4rem;\r\n    background-color: var(--color-static-background);\r\n    touch-action: none;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n}\r\n\r\n.fingerprint-container {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    height: 80%;\r\n    width: 80%;\r\n    /* Defaults for gesture behaviour */\r\n    --gs-translate-x: 0px;\r\n    --gs-transition-enabled: 1;\r\n    transform: translate( calc(-50% + var(--gs-translate-x)), -50% );\r\n    transition: transform calc(var(--gs-transition-enabled) * 0.25s) cubic-bezier(0.25, 0.8, 0.25, 1);\r\n    pointer-events: none;\r\n}\r\n\r\n    .fingerprint-container.static {\r\n        stroke: var(--color-static);\r\n        z-index: 0;\r\n    }\r\n\r\n    .fingerprint-container.dynamic {\r\n        stroke: var(--color-dynamic);\r\n        z-index: 1;\r\n    }\r\n\r\n    .fingerprint-container > svg {\r\n        pointer-events: none;\r\n        height: 100%;\r\n        width: 100%;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
